import React from 'react'
import { RacingEvent } from '@core/Areas/VenueMode/Components/Racing/RacingEvent'
import { EventsContainerStyled } from '@core/Areas/VenueMode/Components/Racing/RacingEvents.styles'
import {
  RacingEventType,
  RacingPropositionType,
} from '@core/Areas/VenueMode/Components/Racing/Data/types'

export interface VenueModeRacesProps {
  events: RacingEventType[]
  selectedItem: RacingPropositionType | null
  onSelectedItemChanged: (proposition: RacingPropositionType, event: RacingEventType) => void
  eventsDisplayCount?: number
}

export const RacingEvents: React.FC<VenueModeRacesProps> = ({
  events,
  selectedItem,
  onSelectedItemChanged,
  eventsDisplayCount,
}) => (
  <EventsContainerStyled>
    {events
      .slice(0, eventsDisplayCount != undefined ? eventsDisplayCount : events.length)
      .map(event => (
        <RacingEvent
          event={event}
          selectedItem={selectedItem}
          onSelectedItemChanged={onSelectedItemChanged}
          key={event.sequence}
        />
      ))}
  </EventsContainerStyled>
)
